export default __webpack_public_path__ + "static/augengesundheit-gesichtspflege-makula-4ac65f402ea244d1b0ac7bd761a14c6f.jpg";